import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import CreateEditViewBilling from "../../components/invoice-section/create-edit-view-billing";
import { useDispatch } from "react-redux";
import { invoiceViewAction } from "../../redux/actions/invoices-action";
import { useParams } from "react-router-dom";

const EditBilling = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [invoice, setInvoice] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(invoiceViewAction(id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setInvoice(data?.data?.[0]);
  };
  const onError = (data) => {
    setLoading(false);
  };
  return (
    <InnerLayout backBtn={true} title="Edit Billing">
      <CreateEditViewBilling
        loading={loading}
        setLoading={setLoading}
        page="edit"
        invoice={invoice}
        disabled={false}
      />
    </InnerLayout>
  );
};

export default EditBilling;
